import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import customTheme from "src/constants/theme";
import classnames from "classnames";
import Routes from "./routes";
import App from "./myapp";

const AppRoot = () => {
  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <App className={classnames(["app", "my_app1"])}>
        <Routes />
      </App>
    </ThemeProvider>
  );
};

export default AppRoot;
